export default "__VITE_PUBLIC_ASSET__30e0e889__"